/**
 * Search-parameter validators for route options.
 *
 * Hand-written rather than Zod, and the reason is measured rather than stylistic. TanStack
 * Router's `autoCodeSplitting` splits a route's COMPONENT into its own chunk but keeps its
 * OPTIONS — `validateSearch`, `beforeLoad`, `loader` — in the eager route tree, because the
 * router must be able to match and validate a URL before deciding what to load. A
 * `z.object()` in `validateSearch` therefore puts the whole of Zod in the initial bundle:
 * 265 KB raw, on the landing page, for three tiny schemas.
 *
 * CLAUDE.md hard rule 12 is untouched by this. It puts validation schemas in
 * `packages/shared` so client and server share ONE definition of a request payload. Search
 * parameters are neither — they never cross the wire as a body, the server never parses
 * them, and there is nothing to share.
 */

/**
 * A `returnTo` that cannot leave the site.
 *
 * Spec 22.3 redirects here with `preserveReturnTo`, so this value comes from a URL a
 * stranger may have composed. `//evil.example` and `https://evil.example` must both be
 * rejected: a login page that redirects anywhere is how a convincing phishing link gets
 * built. One leading slash, not two, and nothing else.
 */
export function siteRelativePath(value: unknown): string | undefined {
  if (typeof value !== 'string') return undefined;
  return /^\/(?!\/)/.test(value) ? value : undefined;
}

/** A token from an emailed link. Absent or malformed becomes '', which the forms report. */
export function tokenParam(value: unknown): string {
  return typeof value === 'string' ? value : '';
}
